import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../axiosInterceptor';

type IntegrationRecord = {
  provider: string;
  is_active: boolean;
};

type IntegrationStatusState = {
  loading: boolean;
  error: boolean;
  errorMessage: string | null;
  data: IntegrationRecord[] | null;
};

const initialState: IntegrationStatusState = {
  loading: false,
  error: false,
  errorMessage: null,
  data: null,
};

export const getIntegrations = createAsyncThunk<
  IntegrationRecord[],
  void,
  { rejectValue: string }
>('getIntegrations', async (_, thunkAPI) => {
  try {
    const { data } = await api.get('/api/integrations');
    return data as IntegrationRecord[];
  } catch (error: any) {
    const message =
      error?.response?.data?.error ||
      error?.response?.data?.message ||
      error?.message ||
      'Failed to load integrations';
    return thunkAPI.rejectWithValue(message);
  }
});

const integrationStatusSlice = createSlice({
  name: 'integrationStatus',
  initialState,
  reducers: {
    resetIntegrations: (state) => {
      state.loading = false;
      state.error = false;
      state.errorMessage = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getIntegrations.pending, (state) => {
      state.loading = true;
      state.error = false;
      state.errorMessage = null;
    });
    builder.addCase(getIntegrations.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    });
    builder.addCase(getIntegrations.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
      state.errorMessage = action.payload ?? 'Failed to load integrations';
    });
  },
});

export const { resetIntegrations } = integrationStatusSlice.actions;
export default integrationStatusSlice.reducer;
